import { render, staticRenderFns } from "./BusinessYearFilter.vue?vue&type=template&id=08db5996"
import script from "./BusinessYearFilter.vue?vue&type=script&lang=ts"
export * from "./BusinessYearFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports